import { t } from "i18next";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { emptyClub, Club } from "../../../../interfaces/club";
import { getClubSingle, updateClub } from "../../../../services/club";
import { Media } from "../../../../interfaces/media";
import Uploader from "../../../general/uploader";
import { regionsList } from "../../../../data/regions.";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminClubEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminClubEdit(props: AdminClubEditProps) {
    const [club, setClub] = useState<Club>(emptyClub);
    const [media, setMedia] = useState<Media[]>([]);

    useEffect(() => {
        getClubSingle(props.id)
            .then(response => {
                const newMedia = response.data.logo.map((m: Media) => {
                    return m;
                });
                setMedia(newMedia);
                setClub(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            document_id: event.target.document_id.value,
            date_foundation: event.target.date_foundation.value,
            city: event.target.city.value,
            region: event.target.region.value,
            country: event.target.country.value,
            website: event.target.website.value,
            email: event.target.email.value,
            address: event.target.address.value,
            phone: event.target.phone.value,
            registry_num: event.target.registry_num.value,
            logo: media.length > 0 ? media[0].id : 0
        }
        updateClub(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }
    
    return (
        <Modal className="admin-club-new-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_club") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { club.id == 0 && 
                    <LoadingSpinner />
                }
                { club.id != 0 && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Container>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Control type="hidden" name="id" required defaultValue={ club.id } />
                                        <Form.Control type="hidden" name="country" value="es" />
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                            <Form.Control type="text" name="name" required defaultValue={ club.name } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="document_id">
                                            <Form.Label>{ t("document_id") }</Form.Label>
                                            <Form.Control type="text" name="document_id" defaultValue={ club.document_id } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="date_foundation">
                                            <Form.Label>{ t("date_foundation") }</Form.Label>
                                            <Form.Control type="date" name="date_foundation" defaultValue={ club.date_foundation } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="region">
                                            <Form.Label>{ t("region") }</Form.Label>
                                            <Form.Select aria-label={t("region")} defaultValue={ club.region }>
                                                <option value="">{ t("select_region") }</option>
                                                { regionsList.map((r: any) => {
                                                    return <option key={ 'region-' + r.code } value={ r.code }>
                                                        { r.label }
                                                    </option>
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="city">
                                            <Form.Label>{ t("city") }</Form.Label>
                                            <Form.Control type="text" name="city" defaultValue={ club.city } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="website">
                                            <Form.Label>{ t("website") }</Form.Label>
                                            <Form.Control type="text" name="website" defaultValue={ club.website } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="email">
                                            <Form.Label>{ t("email") }</Form.Label>
                                            <Form.Control type="text" name="email" defaultValue={ club.email } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Group className="mb-3" controlId="address">
                                            <Form.Label>{ t("address") }</Form.Label>
                                            <Form.Control type="text" name="address" defaultValue={ club.address } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="phone">
                                            <Form.Label>{ t("phone") }</Form.Label>
                                            <Form.Control type="text" name="phone" defaultValue={ club.phone } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="registry_num">
                                            <Form.Label>{ t("registry_num") }</Form.Label>
                                            <Form.Control type="text" name="registry_num" defaultValue={ club.registry_num } />
                                        </Form.Group>
                                    </Col>
                                    <Form.Group className="mb-3 media-field" controlId="media">
                                        <Uploader title={ t("icon_upload_message") }
                                            media={ media } save={ handleMediaEventUpload } />
                                    </Form.Group>
                                </Row>
                            </Container>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
